Barba.Dispatcher.on("transitionCompleted", function () {
    if (!document.getElementById("quotation")) {
        return;
    }
    Global.components.push(
        new Vue({
            el: '#quotation',
            store,
            data: function () {
                return {
                    projectID: document.getElementById("quotation").dataset.projectId,

                    contentLoaded: false,

                    lines: '',
                    agreements: '',
                    numberOfContainers: 0,
                    maintenanceUnits: 0,
                    pricePerUnit: 0,
                    currentContractDurationByLease: 1,

                    updateUrl: document.getElementById("quotation").dataset.updateUrl,
                    editable: false,
                    editableFields: null,
                    editableFieldsTimer: null,
                    shareSelectedAgreement: null,
                    maxLoadingTimer: null,
                    loading: false,
                    signature: null,
                    canvas: null,
                    hiddenAgreementsBeforeChange: []
                }
            },
            computed: {
                showContractVariables() {
                    if(this.agreements === '') {
                        return false;
                    }

                    return true;
                },
                showContractVariablesFull() {
                    if(this.agreements === '') {
                        return false;
                    }

                    return this.agreements.filter((a) => !a.hidden && (a.isLease || a.maintenance)).length > 0;
                },
                shareShowContractLines() {
                    return this.shareSelectedAgreement !== null && (this.shareSelectedAgreement.indexOf('lease') >= 0
                        || this.shareSelectedAgreement.indexOf('buy-with-maintenance') >= 0);
                }
            },
            mounted: function() {

                let selectElement = document.getElementById('accept_agreement');
                if(selectElement) {
                    this.shareSelectedAgreement = selectElement.options[0].value;
                }


                // var url = this.deliveryCostsGetUrl + "?projectID=" + this.projectID;
                //
                // const that = this;
                //
                // API.GET(url).then(response => {
                //     this.handleResponse(that, response);
                // });
            },
            beforeMount() {
                var url = this.updateUrl;

                const that = this;

                this.loading = true;
                API.GET(url).then(response => {
                    this.handleResponse(that, response);
                });
            },
            methods: {
                handleResponse: function(scope, response) {
                    scope.lines = response.lines;
                    scope.agreements = response.agreements;

                    scope.numberOfContainers = response.number_of_containers;
                    scope.maintenanceUnits = response.maintenance_units;
                    scope.pricePerUnit = response.price_per_unit;

                    scope.editable = response.editable;
                    scope.editableFields = response.fields;

                    scope.contentLoaded = true;
                    scope.loading = false;
                    this.setContractDurationByLease();
                },
                onDeliveryModified(payload) {
                    this.editableFields.delivery.modified = payload.modified;
                    this.editableFields.delivery.value = payload.value;

                    this.onPriceModified();
                },
                onArrangementModified(payload) {
                    this.editableFields.arrangement.modified = payload.modified;
                    this.editableFields.arrangement.value = payload.value;

                    this.onPriceModified();
                },
                onMaintenanceModified(payload) {
                    this.editableFields.maintenance.modified = payload.modified;

                    this.onPriceModified();
                },
                onPriceModified() {
                    clearTimeout(this.editableFieldsTimer);

                    this.editableFieldsTimer = setTimeout(function() {
                        this.loading = true;
                        API.PUT(this.updateUrl, this.editableFields).then(response => {
                            this.handleResponse(this, response);
                        });
                    }.bind(this), 250);
                },
                onIsLoading() {
                    this.loading = true;
                    clearTimeout(this.maxLoadingTimer);

                    this.maxLoadingTimer = setTimeout(() => {
                        this.loading = false;
                    }, 20000);
                },
                /*onDeliveryCostsKeyUp() {
                    clearTimeout(this.deliveryCostsKeyUpTimer);

                    const that = this;

                    if (this.deliveryCosts.length > 1) {
                        this.deliveryCostsKeyUpTimer = setTimeout(function () {
                            this.deliveryCostsKeyUpTimer = null;

                            var data = {
                                deliveryCosts: this.deliveryCosts,
                                projectID: this.projectID
                            }

                            API.POST(this.deliveryCostsPostUrl, data).then(response => {
                                that.handleResponse(that, response);
                            });
                        }.bind(this), 500);
                    }
                }*/
                onAgreementsModified(response) {
                    let hiddenAgreementKeys = response;
                    this.agreements.forEach((a) => a.hidden = hiddenAgreementKeys.indexOf(a.id) >= 0)
                    this.setContractDurationByLease();
                },
                setContractDurationByLease(){
                    let x = this.currentContractDurationByLease;
                    this.agreements.forEach(function(a){
                        if(!a.hidden){
                            if(a.id === 'lease-3'){
                                x = 3;
                            }
                            if(a.id === 'lease-5'){
                                x = 5;
                            }
                        }
                    });
                    if(x !== this.currentContractDurationByLease){
                        this.currentContractDurationByLease = x;
                    }
                }
            },
            watch: {

            }
        })
    )
});
